import { connect } from "react-refetch";
import { buildRequest, handleResponse } from "./request";
var defaultOverrides = {
    buildRequest: buildRequest,
    handleResponse: handleResponse
};
export default connect.defaults(defaultOverrides);
